import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { INTAKE_FORMS_PATIENT_CHARTS_PRIMARY_TEXT } from '../../../../utils/constants'
import { getIntakeForms } from '../../../../store/charts/ChartsThunk'
import { useGetPatientsPatientIdQuestionnaires } from '@/api/generated/questionnaire/questionnaire'
import intakeIcon from '../../../../images/charts/intake.png'
import { ChartSection } from '../chart-section/ChartSection'
import { IntakeFormsCards } from './IntakeFormsCards'
import { mergeIntakeFormsAndQuestionnaires } from './intakeFormsAndQuestionnaires'
import './intakeForms.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const IntakeForms = ({ id, userTimeZone, patientChartsSearchRow }) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer?.patientInfo ?? {})
  const [isCollapsed, setCollapsed] = useState(true)
  const isFreshPageRef = useRef(true)
  const hasIntakeForms = !!patientInfo?.[id]?.IntakeFormSummary?.Count
  const intakeForms = patientInfo?.[id]?.IntakeFormsList ?? []

  // Online-visit questionnaires come from a dedicated endpoint (no summary count); fetch on expand.
  const { data: questionnaires } = useGetPatientsPatientIdQuestionnaires(id, {
    query: { enabled: !isCollapsed },
  })

  const intakeFormsList =
    isFreshPageRef.current ? [] : mergeIntakeFormsAndQuestionnaires(intakeForms, questionnaires ?? [])

  useEffect(() => {
    if (!isCollapsed && isFreshPageRef.current) {
      if (hasIntakeForms) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getIntakeForms(id))
      }
      isFreshPageRef.current = false
    }
  }, [isCollapsed])

  return (
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    <ChartSection
      className='chart-intake-forms'
      title={INTAKE_FORMS_PATIENT_CHARTS_PRIMARY_TEXT}
      icon={intakeIcon}
      iconAltText='intake-forms'
      setIsCollapsed={setCollapsed}
      isCollapsed={isCollapsed}
      userTimeZone={userTimeZone}
      emptyText='No intake forms or online visits'
      isWithoutLastUpdated>
      {intakeFormsList.length ?
        <IntakeFormsCards
          intakeFormsList={intakeFormsList}
          chartsId={id}
          userTimeZone={userTimeZone}
          patientChartsSearchRow={patientChartsSearchRow}
        />
      : null}
    </ChartSection>
  )
}
